/**
 * 项目默认配置项
 * primaryColor - 默认主题色
 * navTheme - sidebar theme ['dark', 'light'] 两种主题
 * colorWeak - 色盲模式
 * layout - 整体布局方式 ['sidemenu', 'topmenu'] 两种布局
 * fixedHeader - 固定 Header : boolean
 * fixSiderbar - 固定左侧菜单栏 ： boolean
 * autoHideHeader - 向下滚动时，隐藏 Header : boolean
 * contentWidth - 内容区布局： 流式 |  固定
 *
 * storageOptions: {} - Vue-ls 插件配置项 (localStorage/sessionStorage)
 *
 */

export default {
	primaryColor: '#0064DC', // primary color of ant design
	navTheme: 'dark', // theme for nav menu
	layout: 'sidemenu', // nav menu position: sidemenu or topmenu
	contentWidth: 'Fixed', // layout of content: Fluid or Fixed, only works when layout is topmenu
	fixedHeader: true, // sticky header
	fixSiderbar: true, // sticky siderbar
	autoHideHeader: false, //  auto hide header
	colorWeak: false,
	multiTab: true,
	// vue-ls options
	lsOptions: {
		namespace: 'zbcf_aii__', // key prefix
		name: 'ls', // name variable Vue.[ls] or this.[$ls],
		storage: 'local', // storage name session, local, memory
	},
	ssOptions: {
		namespace: 'zbcf_aii__',
		name: 'ss',
		storage: 'session',
	},
}
